import { LitElement, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { readLocalOrderStorage } from '../../order-storage.js';
import localOrderStorageStyles from './local-order-storage.styles.js';
import { OrderCreatedEvent } from '../../events.js';

@customElement('local-order-storage')
export class LocalOrderStorage extends LitElement {
  static styles = localOrderStorageStyles;

  @state()
  private orders: string[] = readLocalOrderStorage();

  @state()
  private manageOrders = false;

  private renderOrder(order: string) {
    return html`
      <li>
        <span>
          <a href="/order/status/?code=${order}">${order}</a>
        </span>
      </li>
    `;
  }

  private addOrderToList = (event: Event) => {
    if (event instanceof OrderCreatedEvent) {
      const { orderNumber } = event;

      if (!this.orders.includes(orderNumber)) {
        this.orders = [...this.orders, orderNumber];
      }
    }
  };

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener(OrderCreatedEvent.event, this.addOrderToList);
  }

  render() {
    return html`
      ${this.orders.length === 0
        ? html` <p>Du hast noch keine Aufträge auf diesem Gerät.</p> `
        : html`
            <ul>
              ${this.orders.map(this.renderOrder)}
            </ul>
          `}
      ${this.manageOrders
        ? html`<a href="/order/verwalten/"
            >Aufträge hinzufügen oder verwalten</a
          >`
        : nothing}
    `;
  }

  disconnectedCallback() {
    window.removeEventListener(OrderCreatedEvent.event, this.addOrderToList);
    super.disconnectedCallback();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'local-order-storage': LocalOrderStorage;
  }
}
